import React, { useEffect, useRef, useState } from 'react';
import icone from '../../assets/images/info.png';
import icone2 from '../../assets/images/coeur.png';
import {
  CButton,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CTab,
  CTabContent,
  CTabList,
  CTabPanel,
  CTabs,
  CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CPagination,
  CPaginationItem
} from '@coreui/react'
import { BsPersonPlus, BsChevronRight, BsPlayCircle, BsHeartPulse, BsEye, BsPencilSquare, BsTrash, BsSearch } from 'react-icons/bs';
import { useLocation, useNavigate } from "react-router-dom";
import api from '../../service/caller';
import { ToastContainer, toast } from 'react-toastify';
import { usePermissions } from '../../contexts/PermissionContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Tooltip, OverlayTrigger, Button } from 'react-bootstrap';
import './appointment.css';
import EditAppointmentModal from '../clientviews/appointmentmanagment/editappointment';

const Appointments = () => {
  const navigate = useNavigate();

  const [UserData, setUserData] = useState([]);
  const [patients, setPatients] = useState([]);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [appointmentIdToEdit, setAppointmentIdToEdit] = useState(null);
  
  // New state for search and pagination
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [filteredAppointments, setFilteredAppointments] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  // Get patients list
  const fetchPatients = async (page = 1) => {
    try {
      const response = await api.get(`/clinic/patients`);
      setPatients(response.data.patients);
    } catch (error) {
      console.error('Erreur lors de la récupération des patients:', error);
    }
  };
  const handleAddOrEditSignsVital = async (appointmentId) => {
      const existingSignsVital = await fetchSignVitalStatus(appointmentId);
      navigate(`/appointment/${appointmentId}/signvital`, {
          state: { existingSignsVital },  // Passer les signes vitaux existants dans l'état de navigation
      });
  };

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        setUserData(response.data);
      } catch (error) {
        toast.error("Failed to fetch data");
      }
    };
    fetchLoggedUserData();
  }, []);

  const doctorId = UserData._id;

  // liste des appointments 
  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          throw new Error('Token not found');
        }

        const hospitalIds = Array.isArray(UserData.hospital_id) ? UserData.hospital_id : [UserData.hospital_id];

        // Créez une requête pour chaque hospitalId
        const promises = hospitalIds.map(hospitalId =>
          api.get(`/clinic/getAppointmentlist?hospitalId=${hospitalId._id || hospitalId}`, {
            headers: { Authorization: `Bearer ${token}` }
          })
        );

        const responses = await Promise.all(promises);

        // Combiner toutes les données des réponses
        const allAppointments = responses.flatMap(response => response.data);

        // Filtrer les rendez-vous dont paymentstatus est true
        
        const appointmentsWithPaymentStatus = allAppointments.filter(appointment =>
          appointment.paymentStatus === true && 
          appointment.doctorId === UserData._id &&
          !['Cancelled', 'Completed','Archived'].includes(appointment.status) // Filtre sur le statut
        );

        // Ajouter la vérification des signes vitaux pour chaque rendez-vous
        const appointmentsWithSignVitalStatus = await Promise.all(
          appointmentsWithPaymentStatus.map(async (appointment) => {
            const signVitalExists = await fetchSignVitalStatus(appointment._id);
            return {
              ...appointment,
              signVitalExists,  // Ajout de la propriété `signVitalExists` à l'objet appointment
            };
          })
        );

        setAppointments(appointmentsWithSignVitalStatus);  // Mettre à jour l'état avec les rendez-vous filtrés

      } catch (error) {
        console.error('Error fetching appointments:', error);
        toast.error("Failed to fetch appointments");
      }
    };

    if (UserData && UserData.hospital_id) {
      fetchAppointments();
    }
  }, [UserData]);

  // Filter appointments based on search term
  useEffect(() => {
    const filterAppointments = () => {
      if (!searchTerm.trim()) {
        setFilteredAppointments(appointments);
      } else {
        const lowercasedSearch = searchTerm.toLowerCase();
        const filtered = appointments.filter(appointment => {
          // Search in patient name
          const patientName = `${appointment.patientId?.firstname || ''} ${appointment.patientId?.lastname || ''}`.toLowerCase();
          // Search in phone number
          const phoneNumber = appointment.patientId?.phone?.toLowerCase() || '';
          // Search in date
          const appointmentDate = appointment.appointmentDate?.split('T')[0]?.toLowerCase() || '';
          // Search in time
          const appointmentTime = appointment.appointmentTime?.toLowerCase() || '';
          
          return patientName.includes(lowercasedSearch) || 
                 phoneNumber.includes(lowercasedSearch) ||
                 appointmentDate.includes(lowercasedSearch) ||
                 appointmentTime.includes(lowercasedSearch);
        });
        setFilteredAppointments(filtered);
      }
    };

    filterAppointments();
    setCurrentPage(1); // Reset to first page on new search
  }, [searchTerm, appointments]);

  // Calculate pagination
  useEffect(() => {
    // Calculate total pages
    const total = Math.ceil(filteredAppointments.length / itemsPerPage);
    setTotalPages(total || 1); // Ensure at least 1 page even if no results
  }, [filteredAppointments, itemsPerPage]);

  // Get current appointments for display based on pagination
  const getCurrentAppointments = () => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return filteredAppointments.slice(indexOfFirstItem, indexOfLastItem);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Fonction pour vérifier si des signes vitaux existent pour un rendez-vous
  const fetchSignVitalStatus = async (appointmentId) => {
    try {
      const response = await api.get(`/clinic/signvitalforappointment/${appointmentId}`);
      return response.data.signVitaldata;
    } catch (error) {
      console.error('Erreur lors de la vérification des signes vitaux:', error);
      return false; // En cas d'erreur, on suppose qu'il n'y a pas de signes vitaux
    }
  };

  const handleEditClick = (appointmentId) => {
      setAppointmentIdToEdit(appointmentId);
      setIsModalVisible(true);
  };

  const handleModalClose = () => {
      setIsModalVisible(false);
      setAppointmentIdToEdit(null);
  };

  // listes des departments
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await api.get(`/api/departments`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        });

        // Mettre à jour les départements dans l'état
        setDepartments(response.data.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des départements:', error);
      }
    };
    fetchDepartments(); // Appel de la fonction pour récupérer les départements
  }, []);

  const handleViewHistory = () => {
    navigate("/hospitaladmin/appointment_history");
  };

  const handleViewHistory2 = (id) => {
    navigate(`/hospitaladmin/patientfilemedical/${id}`);
  };

  const handleviewcalendar = (doctorId) => {
    // Naviguer vers le calendrier du médecin avec l'ID dans l'URL
    navigate(`/hospitaladmin/doctor/calendar/${doctorId}`);
  };

  const popoverRefs = useRef([]);

  useEffect(() => {
    popoverRefs.current.forEach((popoverEl) => {
      if (popoverEl) {
        new window.bootstrap.Popover(popoverEl, {
          html: true, // Permet de rendre le contenu HTML
          trigger: 'click', // Permet d'afficher le popover au clic
        });
      }
    });
  }, []);

  // Fonction pour déterminer la couleur CoreUI en fonction du statut
  const getStatusColor = (status) => {
    switch (status) {
      case 'Scheduled':
        return 'light';  // light grey for Scheduled
      case 'Cancelled':
        return 'warning'; // orange-ish for Cancelled
      case 'Completed':
        return 'success'; // green for Completed
      default:
        return '';
    }
  };

  // Fonction pour déterminer la classe du badge en fonction du statut
  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'Scheduled':
        return 'badge-scheduled';
      case 'Cancelled':
        return 'badge-cancelled';
      case 'Completed':
        return 'badge-completed';
      default:
        return 'badge-scheduled';
    }
  };

  return (
    <div className="py-4" style={{ fontFamily: 'Arial, sans-serif' }}>
      <div className="card p-4">
        <div className="card-body">
          <div className="row mb-3 justify-content-between">
            <div className="col-md-4" style={{ borderRadius: '15px' }}>
              <div className="input-group" style={{ borderRadius: '15px 0px 0px 15px' }}>
                <span className="input-group-text" style={{ borderRadius: '15px 0px 0px 15px' }}>
                  <BsSearch />
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by patient name, phone, date..."
                  style={{ borderRadius: '0px 15px 15px 0px' }}
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
              </div>
            </div>
            <div className="col-md-6 text-end">
              <button className="btn btn-primary" onClick={handleViewHistory}>
                View history <i className="bi bi-clock-history"></i>
              </button>
            </div>
          </div>
          {/* Légende des statuts avec boutons colorés pour représenter chaque statut */}
      <div className="mt-4">
        <div className="d-flex gap-3">
          <div className="d-flex align-items-center">
            <div className="p-2 bg-light me-2" style={{width: '20px', height: '20px', borderRadius: '3px'}}></div>
            <span>Scheduled</span>
          </div>
          <div className="d-flex align-items-center">
            <div className="p-2 bg-warning me-2" style={{width: '20px', height: '20px', borderRadius: '3px'}}></div>
            <span>Cancelled</span>
          </div>
          <div className="d-flex align-items-center">
            <div className="p-2 bg-success me-2" style={{width: '20px', height: '20px', borderRadius: '3px'}}></div>
            <span>Completed</span>
          </div>
        </div>
      </div>

          <CTable className="mt-5 table ctable-no-border" align="middle" responsive>
            <CTableHead className="thead-light">
              <CTableRow color="primary"> {/* Using color prop for the header row */}
                <CTableHeaderCell scope="col">Time</CTableHeaderCell>
                <CTableHeaderCell scope="col">Date</CTableHeaderCell>
                <CTableHeaderCell scope="col">Patient</CTableHeaderCell>
                <CTableHeaderCell scope="col">Phone number</CTableHeaderCell>
                <CTableHeaderCell scope="col">Actions</CTableHeaderCell>
                <CTableHeaderCell scope="col">Status</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {getCurrentAppointments().map((appointment, index) => (
                <CTableRow 
                  color={getStatusColor(appointment.status)} /* Using color prop instead of className */
                  key={index}
                >
                  <CTableDataCell>
                    <p style={{lineHeight:'5px',marginTop:'15px'}}>{appointment.appointmentTime}</p>
                    <p style={{lineHeight:'5px',width:'40px',backgroundColor:'blue',height:'1px'}}></p>
                    <p style={{lineHeight:'5px'}}>{appointment.appointmentEndTime}</p>
                  </CTableDataCell>
                  <CTableDataCell>{appointment.appointmentDate?.split("T")[0]}</CTableDataCell>
                  <CTableDataCell>{appointment.patientId?.firstname || 'Unknown'} {appointment.patientId?.lastname || 'Unknown'}</CTableDataCell>
                  <CTableDataCell>{appointment.patientId?.phone}</CTableDataCell>
                  <CTableDataCell>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{appointment.signVitalExists ? 'Edit Vital Signs' : 'Add Vital Signs'}</Tooltip>}
                    >
                        <span
                            onClick={appointment.status !== 'Cancelled' && appointment.paymentStatus !== false ? () => handleAddOrEditSignsVital(appointment._id) : null}
                            style={{
                                color: appointment.signVitalExists ? '#198754' : '#0d6efd',
                                fontSize: '1.5rem',
                                cursor: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'default' : 'pointer',
                                pointerEvents: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'none' : 'auto'
                            }}
                        >
                            <BsHeartPulse />
                        </span>
                    </OverlayTrigger>
                    <img
                      className="me-2 ms-2 btn cursor-pointer"
                      onClick={()=>handleViewHistory2(appointment?.patientId?._id)}
                      src={icone}
                      alt="Heart Icon"
                    />
                    <OverlayTrigger placement="top" overlay={<Tooltip>Edit Appointment</Tooltip>}>
                        <span
                            onClick={appointment.status !== 'Cancelled' && appointment.paymentStatus !== false ? () => handleEditClick(appointment) : null}
                            style={{
                                color: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? '#6c757d' : '#ffc107',
                                fontSize: '1.5rem',
                                cursor: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'default' : 'pointer',
                                pointerEvents: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'none' : 'auto'
                            }}
                        >
                            <BsPencilSquare />
                        </span>
                    </OverlayTrigger>
                  </CTableDataCell>
                  <CTableDataCell>
                    {/* Boutons de début de consultation */}
                    {appointment?.type_consultation === 'inperson' && appointment.status === 'Scheduled' && (
                      <a
                        href={`/hospitaladmin/intakeformconsult?patient_id=${appointment?.patientId?._id}&appointmentId=${appointment._id}`}
                        className="btn ms-2"
                        style={{ color: '#0056B3', backgroundColor: '#DFEAF5' }}
                      >
                        Start Appointment
                      </a>
                    )}

                    {appointment?.type_consultation === 'online' && appointment.status === 'Scheduled' && (
                      <a
                        href={`/hospitaladmin/telemedecine?patient_id=${appointment?.patientId?._id}&appointmentId=${appointment._id}`}
                        className="btn ms-2"
                        style={{ color: '#1A5D1A', backgroundColor: '#28A7452B' }}
                      >
                        Start Online Appointment
                      </a>
                    )}
                    <EditAppointmentModal
                        visible={isModalVisible}
                        onClose={handleModalClose}
                        appointmentData={appointmentIdToEdit}
                    />
                  </CTableDataCell>
                </CTableRow>
              ))}
              {getCurrentAppointments().length === 0 && (
                <CTableRow>
                  <CTableDataCell colSpan="6" className="text-center py-4">
                    No appointments found matching your search.
                  </CTableDataCell>
                </CTableRow>
              )}
            </CTableBody>
          </CTable>
          
          {/* Pagination Section */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div>
              Showing {Math.min((currentPage - 1) * itemsPerPage + 1, filteredAppointments.length)} to {Math.min(currentPage * itemsPerPage, filteredAppointments.length)} of {filteredAppointments.length}
            </div>
            {totalPages > 1 && (
              <CPagination aria-label="Page navigation">
                <CPaginationItem 
                  onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                  aria-label="Previous"
                >
                  Previous
                </CPaginationItem>
                
                {/* Display page numbers */}
                {[...Array(totalPages).keys()].map(number => {
                  // For simplicity, show max 5 page numbers
                  if (
                    number + 1 === 1 || 
                    number + 1 === totalPages || 
                    (number + 1 >= currentPage - 1 && number + 1 <= currentPage + 1)
                  ) {
                    return (
                      <CPaginationItem
                        key={number}
                        active={number + 1 === currentPage}
                        onClick={() => handlePageChange(number + 1)}
                      >
                        {number + 1}
                      </CPaginationItem>
                    );
                  } else if (
                    number + 1 === currentPage - 2 || 
                    number + 1 === currentPage + 2
                  ) {
                    return <CPaginationItem key={number}>...</CPaginationItem>;
                  }
                  return null;
                })}
                
                <CPaginationItem 
                  onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
                  disabled={currentPage === totalPages}
                  aria-label="Next"
                >
                  Next
                </CPaginationItem>
              </CPagination>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Appointments;